import React from 'react'
import PropTypes from 'prop-types'

import Row from 'component/utils/Row'
import Col from 'component/utils/Col'

const TotemHeaderCards = ({
  translate,
  headerAverage,
  headerAbove,
  headerUnder,
  headerQuantity,
  calculateWait,
  openModalDetails,
}) => {
  const handleCardClick = (option) => {
    openModalDetails(option)
  }

  return (
    <Row>
      <Col xs={12} md={6} lg={3}>
        <div className='totemreports-header-card'>
          <p className='totemreports-card-description'>
            {translate('totem.reports.filter.header.average')}
          </p>
          <p className='totemreports-card-value'>
            {calculateWait(headerAverage) +
              translate('totem.reports.time.min.abr')}
          </p>
        </div>
      </Col>
      <Col xs={12} md={6} lg={3}>
        <div
          className='totemreports-header-clickable-card'
          onClick={() => handleCardClick('timeAbove')}
        >
          <p className='totemreports-card-description'>
            {translate('totem.reports.filter.header.above')}
          </p>
          <p className='totemreports-card-value'>{headerAbove}</p>
        </div>
      </Col>
      <Col xs={12} md={6} lg={3}>
        <div
          className='totemreports-header-clickable-card'
          onClick={() => handleCardClick('timeUnder')}
        >
          <p className='totemreports-card-description'>
            {translate('totem.reports.filter.header.under')}
          </p>
          <p className='totemreports-card-value'>{headerUnder}</p>
        </div>
      </Col>
      <Col xs={12} md={6} lg={3}>
        <div
          className='totemreports-header-clickable-card'
          onClick={() => handleCardClick('timeAll')}
        >
          <p className='totemreports-card-description'>
            {translate('totem.reports.filter.header.quantity')}
          </p>
          <p className='totemreports-card-value'>{headerQuantity}</p>
        </div>
      </Col>
    </Row>
  )
}

export default TotemHeaderCards

TotemHeaderCards.propTypes = {
  translate: PropTypes.func.isRequired,
  calculateWait: PropTypes.func.isRequired,
  headerAverage: PropTypes.string,
  headerAbove: PropTypes.string,
  headerUnder: PropTypes.string,
  headerQuantity: PropTypes.string,
  openModalDetails: PropTypes.func,
}
